import styled, { css } from 'styled-components';

export const BodyText1Css = css`
  font-family: ${props => props.theme.v2.fontFamily.default};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
`;

export const BodyText2Css = css`
  font-family: ${props => props.theme.v2.fontFamily.default};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
`;

export const BodyText3Css = css`
  font-family: ${props => props.theme.v2.fontFamily.default};
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 22px;
`;

export const BodyText4Css = css`
  font-family: ${props => props.theme.v2.fontFamily.default};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
`;

// Declaring the styled component
const BodyText = styled.span`
  ${props => props.size === 100 && BodyText1Css}
  ${props => props.size === 200 && BodyText2Css}
  ${props => props.size === 300 && BodyText3Css}
  ${props => props.size === 50 && BodyText4Css}
`;

export default BodyText;
